import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { parse } from 'valibot';
import { ArticlesShowParams } from './articles-show-params';
import { Article, ArticleSchema } from '$core/models';

@Injectable({ providedIn: 'root' })
export class ArticlesService {
  private readonly http = inject(HttpClient);

  /**
   * API version.
   */
  private readonly apiVersion = 'v1';

  /**
   * Returns the article by its key.
   *
   * @param params - The parameters for retrieving the article.
   * @returns The retrieved article.
   *
   * @public
   */
  public show(params: ArticlesShowParams): Observable<Article> {
    const { key } = params;

    return this.http
      .get<unknown>(`/${this.apiVersion}/articles/${key}`)
      .pipe(map((response) => parse(ArticleSchema, response)));
  }
}
